<template>
  <v-app>
    <v-overlay v-if="showOverlay" :z-index="100" :value="true">
      <v-alert type="info" rounded="lg" color="primary">upgrading</v-alert>
    </v-overlay>

    <system-loading />
    <deposit-modal />
    <borrow-modal />
    <!-- <mint-modal /> -->
    <!-- <payback-modal /> -->
    <faucet-modal />
    <monadtest-faucet-modal />
    <switch-network-modal />
    <enter-markets-modal />
    <mint-syn-modal />
    <tx-load-modal />
    <redemption-modal />
    <protected-mint-syn-modal />
    <!-- <liquidate-modal /> -->
    <message-modal />

    <top-bar
      v-model="drawer"
      :navigateList="navigateList"
      :currentLinkName="currentLinkName"
      :setCurrentLinkName="setCurrentLinkName"
      :jump="jump"
      :totalDeposit="totalDeposit"
      :totalBorrowed="totalBorrowed"
      :totalSuLiquidity="totalSuLiquidity"
    />

    <v-snackbars :objects.sync="snackbarsObj">
      <template v-slot:action="{ index }">
        <v-btn text @click="viewScan(index)">view scan</v-btn>
      </template>
    </v-snackbars>

    <v-main class="grey lighten-3">
      <div class="outer-container px-md-4">
        <v-container>
          <!-- <v-alert v-if="currentNetwork.networkId === getStayNetworkId()" type="info" rounded="lg" color="primary">The existing suBTC circulation on Core network was mainly created and bridged from other networks like zkLink.  Core deposit campaign will start soon</v-alert> -->
          <v-alert v-if="errorInfo && $route.name === 'Dashboard'" type="warning" rounded="lg">{{ errorInfo }}</v-alert>
          <router-view />
        </v-container>
      </div>
      <div class="loop-tag" v-if="whiteListRoute.includes(routeName) && isSupportNetwork">
        <v-chip class="ma-2" color="#987f61" text-color="white" link @click="doInitMarket">
          <span v-if="!systemLoading">{{ loopTagText }}</span>
          <span v-else><v-progress-circular size="18" width="3" indeterminate></v-progress-circular></span>
        </v-chip>
      </div>
    </v-main>
    <bottom-bar />
    <section v-if="mobile">
      <v-navigation-drawer v-model="drawer" fixed temporary>
        <v-list-item>
          <v-list-item-avatar>
            <img src="/logo.png" alt="" />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>Sumer.Money</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list dense>
          <v-list-item v-for="item in navigateList" :key="item.title" link @click="jump(item)">
            <!-- <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon> -->

            <v-list-item-content>
              <v-list-item-title
                v-if="item.name !== 'Points'"
                :class="{ 'font-weight-bold': item.name === currentLinkName }"
                >{{ item.name }}</v-list-item-title
              >
              <v-list-item-title v-else class="font-italic">
                {{ item.name }}
                <v-icon size="large" color="blue">mdi-rocket-launch</v-icon>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <section class="pa-4">
          <div v-if="msg.length">
            <v-badge color="red" dot offset-x="10" offset-y="10">
              <v-btn rounded class="ml-1 text-color" small elevation="0" @click="showMessage">Message</v-btn>
            </v-badge>
          </div>
        </section>

        <section class="px-4">
          <v-sheet rounded="xl" outlined class="px-4" elevation="0">
            <div class="d-flex flex-column align-center">
              <span class="text-color">Total Deposit</span>
              <h3 class="text-color-light">{{ totalDeposit | usd1 }}</h3>
            </div>
          </v-sheet>
          <v-sheet rounded="xl" outlined class="px-4 mt-4" elevation="0">
            <div class="d-flex flex-column align-center">
              <span class="text-color">Total Borrow</span>
              <h3 class="text-color-light">{{ totalBorrowed | usd1 }}</h3>
            </div>
          </v-sheet>
          <v-sheet rounded="xl" outlined class="px-4 mt-4" elevation="0">
            <div class="d-flex flex-column align-center">
              <span class="text-color">Total SuToken Issued</span>
              <h3 class="text-color-light">{{ totalSuLiquidity | usd1 }}</h3>
            </div>
          </v-sheet>
        </section>
      </v-navigation-drawer>
    </section>
  </v-app>
</template>

<script>
import TopBar from './top.vue'
import BottomBar from './bottom.vue'

import SystemLoading from '@/components/SystemLoading'
import DepositModal from '../Modal/DepositModal'
import BorrowModal from '../Modal/BorrowModal'
// import MintModal from '../Modal/MintModal'
// import PaybackModal from '../Modal/PaybackModal'
import FaucetModal from '../Modal/FaucetModal'
import MonadtestFaucetModal from '../Modal/MonadtestFaucetModal'
import SwitchNetworkModal from '../Modal/SwitchNetworkModal'
import EnterMarketsModal from '../Modal/EnterMarketsModal'
import MintSynModal from '../Modal/MintSynModal'
import TxLoadModal from '../Modal/TxLoadModal'
import RedemptionModal from '../Modal/RedemptionModal'
import ProtectedMintSynModal from '../Modal/ProtectedMintSynModal'
// import LiquidateModal from '../Modal/LiquidateModal'
import MessageModal from '../Modal/MessageModal'

import VSnackbars from 'v-snackbars'
import { mapActions, mapState } from 'vuex'
import { DEFAULT_ADDRESS, SHYLOCK_BASE_URL, StayNetworkId, supportNetworkList, upgradingNetwork } from '../../constants'
import mixins from '../../mixins'
import BigNumber from 'bignumber.js'
import axios from 'axios'
import { mapMutations } from 'vuex/dist/vuex.common.js'

const LOOP_TIME = 30

export default {
  name: 'Layout',
  mixins: [mixins],
  components: {
    TopBar,
    BottomBar,

    SystemLoading,
    DepositModal,
    BorrowModal,
    // MintModal,
    // PaybackModal,
    FaucetModal,
    MonadtestFaucetModal,
    SwitchNetworkModal,
    EnterMarketsModal,
    MintSynModal,
    TxLoadModal,
    RedemptionModal,
    ProtectedMintSynModal,
    // LiquidateModal,
    MessageModal,

    'v-snackbars': VSnackbars,
  },
  data() {
    return {
      drawer: false,
      navigateList: [
        { name: 'Dashboard', path: '/' },
        { name: 'Bridge', path: '/bridge' },
        { name: 'Defi', path: '/defi' },
        { name: 'Points', path: '' },
        { name: 'Analytics', path: '/analytics' },
      ],
      currentLinkName: 'Dashboard',
      totalDeposit: new BigNumber(0),
      totalBorrowed: new BigNumber(0),
      totalSuLiquidity: new BigNumber(0),

      overlay: true,
      snackbarsObj: [],
      snackbarsAlreadyShow: [],
      loopTime: LOOP_TIME,
      routeName: '',
      whiteListRoute: ['Dashboard', 'TokenList', 'TokenDetail'],
    }
  },
  watch: {
    txInfos(tx) {
      const txOk = tx.filter((t) => t.status === 'ok')
      for (const t of txOk) {
        if (!this.snackbarsAlreadyShow.includes(t.hash)) {
          const message = `${t.title} ${t.amount ? t.amount : ''} ${t.symbol} success`
          this.snackbarsAlreadyShow.push(t.hash)
          this.snackbarsObj.push({
            message,
            hash: t.hash,
            top: true,
            right: true,
            color: 'primary',
            timeout: 10000,
          })
        }
      }
    },
    '$route.name': {
      handler(val) {
        this.routeName = val
      },
      immediate: true,
    },
    loopTime(val) {
      if (val === 0) {
        this.initMarket()
      }
    },
  },
  computed: {
    ...mapState('wallet', ['currentNetwork', 'isSupportNetwork', 'account', 'initLoading', 'isWalletReset']),
    ...mapState('tx', ['txInfos']),
    ...mapState('market', ['errorInfo']),
    ...mapState('loading', ['systemLoading']),
    ...mapState('message', ['msg']),
    isTxPending() {
      return this.txInfos.find((t) => t.status === 'pending')
    },
    loopTagText() {
      if (this.mobile) {
        return `${this.loopTime}s`
      }
      return `refresh in ${this.loopTime}s`
    },
    showOverlay() {
      if (this.currentNetwork && upgradingNetwork.includes(this.currentNetwork.networkId)) {
        return true
      }
      return false
    },
  },
  mounted() {
    setInterval(() => {
      this.loopTime--
      if (
        this.loopTime === -1 ||
        this.isTxPending ||
        this.systemLoading ||
        !this.isSupportNetwork ||
        !this.whiteListRoute.includes(this.routeName) ||
        this.showOverlay ||
        this.account === DEFAULT_ADDRESS ||
        process.env.VUE_APP_PRODUCTION === 'false'
      ) {
        this.loopTime = LOOP_TIME
      }
    }, 1000)

    this.getSummary()
  },
  methods: {
    ...mapActions({
      initBridge: 'suTokenBridge/initChain',
      initMarket: 'market/initMarket',
      initShylock: 'shylock/initShylockAccount',
      initSummary: 'collect/initSummary',
    }),
    ...mapMutations({
      showMessage: 'modal/SHOW_MESSAGE',
    }),
    async getSummary() {
      const res = await axios.get(`${SHYLOCK_BASE_URL}/metadata`)
      const netIds = []
      supportNetworkList.map((net) => {
        if (!net.isTestnet) {
          netIds.push(net.networkId)
        }
      })

      let tempTotalDeposit = new BigNumber(0)
      let tempTotalBorrowed = new BigNumber(0)
      let tempTotalSuMinted = new BigNumber(0)
      for (const id of Object.keys(res.data)) {
        if (netIds.includes(Number(id))) {
          tempTotalDeposit = tempTotalDeposit.plus(res.data[id].totalDepositVal)
          tempTotalBorrowed = tempTotalBorrowed.plus(res.data[id].totalBorrowsVal)
          tempTotalSuMinted = tempTotalSuMinted.plus(res.data[id].totalMintedSyntheticVal)
        }
      }

      this.totalDeposit = tempTotalDeposit
      this.totalBorrowed = tempTotalBorrowed
      this.totalSuLiquidity = tempTotalSuMinted

      // get totalSuLiquidity from jifen api
      // const res1 = await axios.get("https://jifen.meter.io/api/snapshot/totalSuLPLiquidity")
      // // console.log('res1', res1)
      // if (res1.data.results) {
      //   this.totalSuLiquidity = new BigNumber(res1.data.results)
      // }
    },
    setCurrentLinkName(routeName) {
      console.log('routeName', routeName)
      if (['Account', 'Plan'].includes(routeName)) {
        this.currentLinkName = 'Liquidation'
      } else if (['TokenList', 'TokenDetail'].includes(routeName)) {
        this.currentLinkName = 'Market'
      } else if (['Summary', 'CollectDetail'].includes(routeName)) {
        this.currentLinkName = 'Analytics'
      } else {
        this.currentLinkName = routeName
      }
    },
    jump(link) {
      if (link.name === 'Points') {
        window.open('https://points.sumer.money')
        return
      }
      if (link.name !== this.currentLinkName) {
        this.currentLinkName = link.name
        if (link.name === 'Liquidation') {
          this.$router.push({
            name: 'Account',
          })
        } else if (link.name === 'Market') {
          this.$router.push({
            name: 'TokenList',
          })
        } else if (link.name === 'Analytics') {
          this.$router.push({
            name: 'Summary',
          })
        } else {
          this.$router.push({
            name: link.name,
          })
        }
        console.log('link.path', link.path)
        if (!this.isWalletReset) {
          if (link.path === '/bridge') {
            this.initBridge()
          } else if (link.path === '/liquidation') {
            this.initShylock()
          } else if (link.path.includes('collect')) {
            this.initSummary()
          } else if (link.path === '/gasSwap') {
          } else if (link.path === '/defi') {
          } else {
            this.initMarket()
          }
        }
      }
    },

    viewScan(index) {
      const data = this.snackbarsObj[index]
      window.open(`${this.currentNetwork.blockExplorer}/tx/${data.hash}`)
    },
    doInitMarket() {
      if (this.initLoading || this.systemLoading || this.isTxPending || !this.isSupportNetwork) return
      this.initMarket()
    },
    getStayNetworkId() {
      return StayNetworkId
    },
  },
}
</script>

<style lang="scss">
.v-btn {
  text-transform: none;
}

.outer-container {
  height: 100%;
  background: url(../../assets/images/bg.png) left center no-repeat;
  // background-color: darken(#f8f5f2, 25%);
  background-size: cover;
  background-attachment: fixed;
}

.loop-tag {
  position: fixed;
  z-index: 1000;
  bottom: 0;
  right: 0;
  // opacity: 0.8;
}

.v-sheet {
  box-shadow: rgba(58, 78, 88, 0.09) 0px 0px 16px !important;
  border: 1px solid #eaddcf;
}
</style>
